import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'add-pages-modal',
  templateUrl: './add-pages-modal.component.html',
  styleUrls: ['./add-pages-modal.component.css']
})
export class AddPagesModalComponent {
  pages = 1;
  LOCALIZATION: any = {};
  
  constructor(public activeModal: NgbActiveModal,
  private userService: UserService) {}
  
  ngOnInit(): void {
  	this.LOCALIZATION = this.userService.LOCALIZATION;
  }
   
  addPages() {
    this.activeModal.close(this.pages);
  }
  close(): void {
	this.activeModal.dismiss();
  }
}
